export const tokenRefreshedMock = {
  accessToken: 'SDSA.DFGFD.SGD',
};
